<template>
  <w-dialog :show="visible"
            confirm
            show-close
            :box-style="{width:'300px'}"
            :bodyStyle="{padding: 0}"
            @close="close">
    <div class="text-align-center" style="padding: 44px 34px 40px 34px;">
      <div class="text-align-center" style="height: 72px;">
        <div class="inline-block" style="width: 72px;height: 72px;background: #00C461;border-radius: 50%;">
          <i class="r2-icon-nav_check inline-block" style="color: #ffffff;font-size: 48px;"></i>
        </div>
      </div>
      <div style="height: 32px;font-size: 24px;font-weight: 500;color: #212530;line-height: 32px;margin-top: 32px;">
        提交成功
      </div>
      <div style="margin: 16px 0 37px 0;color: rgba(33, 37, 48, 0.55);">
        申诉结果会在 1-5 个工作日内通过系统消息给您通知，请您耐心等待。
      </div>
      <div>
        <w-button type="primary" @click="close()" size="small">确定</w-button>
      </div>
    </div>
  </w-dialog>
</template>

<script>
export default {
  name: 'Success',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 关闭弹窗
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
